import React, { useEffect, useRef, useState } from 'react'
import {
  Button,
  ButtonToolbar,
  Col,
  Image,
  OverlayTrigger,
  Row,
  Table,
  Tooltip
} from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import { BsPlusLg } from 'react-icons/bs'
import { useDebounce } from '@react-hook/debounce'
import SwalCustom from '../../alert/swal-custom'
import moment from 'moment'
import { Select } from 'antd'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { getContractSettingAPI } from '../../services/setting-contracts'
import EditContracts from '../../components/contracts-setting/edit-contracts'
import AddContracts from '../../components/contracts-setting/add-contracts'
import NavRoleOrg from '../../components/nav-role-org'
import { useSelector } from 'react-redux'
import TextNavTitle from '../../components/TextNavTitle'
import editImg from '../../images/Edit.svg'
import CardCustom from '../../components/custom/card-custom'
import useNumberInput from '../../helper/input-fix-num'
import SpinnerLoading from '../../components/spinner-loading'
import InputIDCardNumber from '../../components/input-idcard-num'
export default function ContractsPage() {
  const orgId = useSelector((state) => state.roleReducer.role)

  const [showCreate, setShowCreate] = useState(false)
  const [dataTable, setdataTable] = useState([])
  const [showEdit, setShowEdit] = useState(false)
  const [detailTable, setDetailTable] = useState()
  const [isRefresh, setIsRefresh] = useState(false)

  const [search, setSearch] = useDebounce('', 1000)
  const [logInStatusId, setLogInStatusId] = useState(1)
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(20)
  const [numLoad, setNumLoad] = useState(1)
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const body = {
      page: numLoad !== 1 ? 1 : page,
      searchs: search,
      size: totalLimits,
      orgId: orgId,
      logInStatusId: logInStatusId
    }

    setPage(numLoad !== 1 ? 1 : page)
    getContractSetting(body)
    setIsRefresh(false)
    setNumLoad(numLoad + 1)
  }, [isRefresh, search, logInStatusId, orgId])

  const getContractSetting = async (body) => {
    setIsLoading(true)
    const res = await getContractSettingAPI(body)
    setIsLoading(false)

    if (!res) return
    if (res.status) {
      setdataTable(res.result)
      setTotalRows(res.totalRows)
      setTotalLimits(res.totalLimits)
    }
  }

  const [isSave, setIsSave] = useState(false)

  const onCancel = (d) => {
    const holidayId = d.id
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to cancel?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'var(--comp-badge-color-background-primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, cancel it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        // cancelHoliday(holidayId);
      }
    })
  }

  const handleEditButtonClick = () => {
    setShowEdit(true)
  }

  const status = [
    {
      value: '',
      label: 'All'
    },
    {
      value: 1,
      label: 'Active'
    },
    {
      value: 2,
      label: 'Inactive'
    }
  ]
  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Setting Contracts</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <Col xl={12}>
        <CardCustom border="0" className="h-full">
          <div className="p-3 row">
            <div className="col-4">
              <h4 className="text-muted mb-0" style={{ float: 'left' }}>
                Contracts
              </h4>
            </div>
            {orgId ? (
              <div className=" d-flex justify-content-end col-8 gap-1">
                <span className="me-1 col-4">
                  <InputIDCardNumber
                    placeholder="ID Card"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </span>

                <span className="me-5 w-25 col-1">
                  <Select
                    className="w-100"
                    options={status}
                    defaultValue="Active"
                    onChange={setLogInStatusId}
                  ></Select>
                </span>

                <span className="col-2 d-flex justify-content-end ">
                  <Button
                    className="border-0 px-4 w-100"
                    style={{
                      // width: '200px',
                      minWidth: '160px'
                    }}
                    size="sm"
                    onClick={() => setShowCreate(true)}
                  >
                    <BsPlusLg /> Add Contracts
                  </Button>
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
          {/* <Index /> */}
          <Table hover responsive>
            <thead
              className="bg-hrms text-white font-title-table"
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr>
                <th className=" fw-normal">#</th>
                <th className=" fw-normal">ID Card</th>
                <th className=" fw-normal ">Insert By</th>
                <th className=" fw-normal text-center">Insert Date</th>
                <th className=" fw-normal text-center ">Status</th>
                <th className=" fw-normal text-center ">Action</th>
                {/* <th className=" fw-normal text-center">Cancel</th> */}
              </tr>
            </thead>
            <tbody>
              {dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr key={i} className="fw-light font-small-2">
                    <td> {page * totalLimits - totalLimits + i + 1}</td>
                    <td>{d.id_card}</td>
                    <td className="">{d.insert_by}</td>
                    <td className="text-center">
                      {moment(d.insert_date).format('DD/MM/YYYY')}
                    </td>
                    <td className="text-center">
                      {d.status_id === 1 ? (
                        <div
                          className="rounded-2"
                          style={{
                            // backgroundColor: ""var(--comp-badge-color-background-primary)"",
                            color: 'var(--comp-badge-color-background-primary)'
                          }}
                        >
                          Active
                        </div>
                      ) : (
                        <div
                          className="rounded-2"
                          style={{
                            // backgroundColor: "#C6C6C6",
                            color: 'grey'
                          }}
                        >
                          Inactive
                        </div>
                      )}
                    </td>

                    <td className="text-center">
                      <ButtonToolbar className="d-flex justify-content-center">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-detail">Edit</Tooltip>}
                        >
                          <Button
                            variant="btn btn-outline-primary"
                            className="border-0 "
                            size="sm"
                            style={{
                              width: '32px',
                              height: '32px'
                            }}
                            onClick={() => {
                              setDetailTable(d)
                              handleEditButtonClick()
                            }}
                          >
                            <Image
                              src={editImg}
                              style={{
                                width: '20px'
                              }}
                            />
                          </Button>
                        </OverlayTrigger>
                      </ButtonToolbar>
                      {/* <Button
                        style={{
                          backgroundColor: "#1A2B45",
                          border: "1px solid #1A2B45",
                          width: "110px",
                        }}
                        type="button"
                        size="sm"
                        onClick={() => {
                          setDetailTable(d);
                          handleEditButtonClick();
                        }}
                      >
                        Edit
                      </Button> */}
                    </td>
                  </tr>
                ))
              ) : !orgId ? (
                <tr className="mb-0">
                  <td className="text-center small" colSpan={6}>
                    - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
                  </td>
                </tr>
              ) : isLoading ? (
                <tr className="mb-0">
                  <td className="text-center" colSpan={6}>
                    <SpinnerLoading />
                  </td>
                </tr>
              ) : (
                <tr className="fw-light ">
                  <td colSpan={6} className="text-center">
                    - No data -
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="pt-3">
            <PaginationControl
              page={page}
              total={totalRows}
              limit={totalLimits}
              changePage={(page) => {
                const body = {
                  page: page,
                  logInStatusId: logInStatusId,
                  searchs: search,
                  size: totalLimits
                }
                getContractSetting(body)
                setPage(page)
              }}
              ellipsis={1}
            />
          </div>
        </CardCustom>
      </Col>

      {showCreate && (
        <AddContracts
          orgId={orgId}
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          setIsSave={setIsSave}
          showCreate={showCreate}
          isSave={isSave}
          fnGetData={getContractSetting}
          setShowCreate={setShowCreate}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
      {showEdit && (
        <EditContracts
          orgId={orgId}
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          detail={detailTable}
          setIsSave={setIsSave}
          showCreate={showEdit}
          isSave={isSave}
          fnGetData={getContractSetting}
          setShowCreate={setShowEdit}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
    </Row>
  )
}
